import React, { Component } from 'react';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

class SignUpForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            email: '',
            password: '',
            username: '',
        };
  
    }
  
    componentDidMount() {  
  
        //when I signed in or signed out - add this listener 
        firebase.auth().onAuthStateChanged((firebaseUser) => {
            if (firebaseUser) {                 //if exists, then we logged in
                console.log("Logged in as", firebaseUser.email);
                this.setState({ user: firebaseUser })
            } else {
                console.log("Logged out");
                this.setState({ user: null })
            }
        })
  
    }
  
    //A callback function for registering new users
    handleSignUp = () => {
        this.setState({ errorMessage: null }); //clear old error
  
        console.log("Creating user", this.state.email);
  
        firebase.auth().createUserWithEmailAndPassword(this.state.email, this.state.password)
            .then((userCredential) => {
                let user = userCredential.user;
                console.log(user);
  
                let updatePromise = user.updateProfile({ displayName: this.state.username })
                return updatePromise;
            })
            .then(() => {   //this updates the state so that it immediately updates the banner
                this.setState((prevState) => {
                    let updatedUser = { ...prevState.user, displayName: this.state.username }
                    var user = firebase.auth().currentUser;
                    var uid=user.uid;
        
                    var usersRef = firebase.database().ref('users/' + uid);
                        usersRef.set({
                            characterName: "nothing",
                            characterImage: "nothing",
                            username: uid,
                    });
                    return { user: updatedUser }; //updating the state
                });
            })
            .catch((err) => {
                this.setState({ errorMessage: err.message });
            })
    }
  
    //A callback function for logging in existing users
    handleSignIn = () => {
        this.setState({ errorMessage: null }); //clear old error
  
        firebase.auth().signInWithEmailAndPassword(this.state.email, this.state.password)
            .then((userCredential) => {
                let firebaseUser = userCredential.user;
                console.log(firebaseUser);
                this.setState({ user: firebaseUser });
            })
            .catch((err) => {
                this.setState({ errorMessage: err.message });
            })
    }
  
    //A callback function for logging out the current user
    handleSignOut = () => {
        this.setState({ errorMessage: null }); //clear old error
  
        firebase.auth().signOut();
    }
  
    handleChange = (event) => {
        let field = event.target.name; //which input
        let value = event.target.value; //what value
  
        let changes = {}; //object to hold changes
        changes[field] = value; //change this field
        this.setState(changes); //update state
    }
  
    render() {
        return (
            <Container>
                <Row>
                    <h1 className="authentication-title">Authentication</h1>
                </Row>
                <Row className="authentication-content">
                    <Col md={6} xl={8}>
                        <div className="form-group">
                            <label>Email:</label>
                            <input className="form-control"
                                name="email"
                                value={this.state.email}
                                onChange={this.handleChange}
                            />
                        </div>
        
                        <div className="form-group">
                            <label>Password:</label>
                            <input type="password" className="form-control"
                                name="password"
                                value={this.state.password}
                                onChange={this.handleChange}
                            />
                        </div>
        
                        <div className="form-group">
                            <label>Username:</label>
                            <input className="form-control"
                                name="username"
                                value={this.state.username}
                                onChange={this.handleChange}
                            />
                        </div>
        
                        <div className="form-group mb-5">
                            <button onClick={this.handleSignUp}>
                                Sign Up
                            </button>
                            <button onClick={this.handleSignIn}>
                                Sign In
                            </button>
                            <button onClick={this.handleSignOut}>
                                Sign Out
                            </button>
                        </div>
                    </Col>
                    <Col md={6} xl={4}>
                        <img id="authentication-pic" className="center-block" src="https://i.ya-webdesign.com/images/animal-crossing-png-8.png" alt="animal-crossing"/>
                    </Col>
                    
                </Row>
  
                {/* Only included if first clause is true */}
                {this.state.errorMessage &&
                    <p className="alert alert-danger">{this.state.errorMessage}</p>
                }
  
                {this.state.user &&
                    <div className="alert alert-success"><h3>Logged in as {this.state.user.displayName}</h3></div>
                }
  

            </Container>
        );
    }
  }

  export default SignUpForm;

  export {SignUpForm};